
import { en } from './en'
import { zh } from './zh'
import { tw } from './tw'
import { pt } from './pt'
import { it } from './it'
import { ja } from './ja'

let postureHome = {
  'cn': zh.postureHome,
  'zhHant': tw.postureHome,
  'en': en.postureHome,
  'pt': pt.postureHome,
  'it': it.postureHome,
  'ja': ja.postureHome
}
let posture = {
  'cn': zh.posture,
  'zhHant': tw.posture,
  'en': en.posture,
  'pt': pt.posture,
  'it': it.posture,
  'ja': ja.posture
}
let postureIpad = {
  'cn': zh.postureIpad,
  'zhHant': tw.postureIpad,
  'en': en.postureIpad,
  'pt': pt.postureIpad,
  'it': it.postureIpad,
  'ja': ja.postureIpad
}
let postureModal = {
  'cn': zh.postureModal,
  'zhHant': tw.postureModal,
  'en': en.postureModal,
  'pt': pt.postureModal,
  'it': it.postureModal,
  'ja': ja.postureModal
}
let postureModalIpad = {
  'cn': zh.postureModalIpad,
  'zhHant': tw.postureModalIpad,
  'en': en.postureModalIpad,
  'pt': pt.postureModalIpad,
  'it': it.postureModalIpad,
  'ja': ja.postureModalIpad
}
let postureReport = {
  'cn': zh.postureReport,
  'zhHant': tw.postureReport,
  'en': en.postureReport,
  'pt': pt.postureReport,
  'it': it.postureReport,
  'ja': ja.postureReport
}
let postureSymp = {
  'cn': zh.postureSymp,
  'zhHant': tw.postureSymp,
  'en': en.postureSymp,
  'pt': pt.postureSymp,
  'it': it.postureSymp,
  'ja': ja.postureSymp
}
let postureSympIpad = {
  'cn': zh.postureSympIpad,
  'zhHant': tw.postureSympIpad,
  'en': en.postureSympIpad,
  'pt': pt.postureSympIpad,
  'it': it.postureSympIpad,
  'ja': ja.postureSympIpad
}
let sympItem = {
  'cn': zh.sympItem,
  'zhHant': tw.sympItem,
  'en': en.sympItem,
  'pt': pt.sympItem,
  'it': it.sympItem,
  'ja': ja.sympItem
}
let sympItemIpad = {
  'cn': zh.sympItemIpad,
  'zhHant': tw.sympItemIpad,
  'en': en.sympItemIpad,
  'pt': pt.sympItemIpad,
  'it': it.sympItemIpad,
  'ja': ja.sympItemIpad
}
export {
  postureHome,
  posture,
  postureIpad,
  postureModal,
  postureModalIpad,
  postureReport,
  postureSymp,
  postureSympIpad,
  sympItem,
  sympItemIpad
}



// WEBPACK FOOTER //
// ./src/assets/lang.conf/root.js